import { flatten, get } from 'lodash';
import InputType from 'models/enums/InputType';
import ProductDocumentPropertyPath from 'models/enums/ProductDocumentPropertyPath';
import { convertProductPropertyByInputType } from './Utils.Other.ProductInputTypeMappings';

export function getProductDocumentsFinalFields(
  contract: Model.IContract,
  productDocuments: Model.IProductDocument[],
  additionalFields: {
    productDocumentId: number;
    key: string;
    value: string | number | boolean;
  }[]
) {
  return flatten(productDocuments?.map((d) => d.productAdditionalFields)).map((f) => {
    if (f.propertyPath) {
      return {
        productDocumentId: f.productDocumentId,
        key: f.key,
        value: convertProductPropertyByInputType({
          propertyPath: f.propertyPath as ProductDocumentPropertyPath,
          value: get({ contract: contract }, f.propertyPath),
          inputLabel: f.label || f.key,
          inputType: f.type as InputType,
          options: {
            isPackage: contract?.isPackage,
            isTaxExempt: contract?.client?.taxExempt,
          },
        }),
      };
    } else {
      const additionalField = additionalFields?.find(
        (it) => it.key == f.key && it.productDocumentId === f.productDocumentId
      );
      return {
        productDocumentId: f.productDocumentId,
        key: f.key,
        value: convertProductPropertyByInputType({
          value: additionalField?.value,
          inputLabel: f.label || f.key,
          inputType: f.type as InputType,
          options: {
            isPackage: contract?.isPackage,
            isTaxExempt: contract?.client.taxExempt,
          },
        }),
      };
    }
  });
}

export function getProductEnhancementsDocumentsFinalFields(
  contract: Model.IContract,
  productEnhancementDocuments: Model.IProductEnhancementDocument[],
  enhancementAdditionalFields: {
    productEnhancementDocumentId: number;
    key: string;
    value: string | number | boolean;
  }[]
) {
  return flatten(productEnhancementDocuments?.map((d) => d.productEnhancementAdditionalFields)).map((f) => {
    if (f.propertyPath) {
      return {
        productEnhancementDocumentId: f.productEnhancementDocumentId,
        key: f.key,
        value: convertProductPropertyByInputType({
          propertyPath: f.propertyPath as ProductDocumentPropertyPath,
          value: get({ contract: contract }, f.propertyPath),
          inputLabel: f.label || f.key,
          inputType: f.type as InputType,
          options: {
            isPackage: contract?.isPackage,
            isTaxExempt: contract?.client?.taxExempt,
            revision: {
              exist: contract?.revisionNumber > 0,
              number: contract?.revisionNumber,
            },
          },
        }),
      };
    } else {
      const enhancementAdditionalField = enhancementAdditionalFields?.find(
        (it) => it.key == f.key && it.productEnhancementDocumentId === f.productEnhancementDocumentId
      );
      return {
        productEnhancementDocumentId: f.productEnhancementDocumentId,
        key: f.key,
        value: convertProductPropertyByInputType({
          value: enhancementAdditionalField?.value,
          inputLabel: f.label || f.key,
          inputType: f.type as InputType,
          options: {
            isPackage: contract?.isPackage,
            isTaxExempt: contract?.client.taxExempt,
            revision: {
              exist: contract?.revisionNumber > 0,
              number: contract?.revisionNumber,
            },
          },
        }),
      };
    }
  });
}
